import { grupoConteudo } from "./grupoConteudo";
import { tipoQuestao } from "./tipoQuestao";
import { tipoUsuario } from "./tipoUsuario";
import { tipoProva } from "./tipoProva";

export const administracao = [
  ...grupoConteudo,
  ...tipoQuestao,
  ...tipoUsuario,
  ...tipoProva
];



// WEBPACK FOOTER //
// ./src/routes/prova/administracao/index.js